// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import padding, { PaddingProps } from '../styled/padding';
import margin, { MarginProps } from '../styled/margin';
import size, { SizeProps } from '../styled/size';

const Card = styled.div<PaddingProps & MarginProps & SizeProps>`
  ${size}
  ${padding}
  ${margin}
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 50px #00000029;
  border-radius: 6px;
`;

export default Card;
